import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../gd-components/base-component/base-component";

import VScroll from '../../../../gd-components/scrolling/custom-v-scroll/v-scroll';

import ModalV4HeaderWhite from "../../../../../app/ui/modal/v4/header-white/v4-header-white";
import SearchInput from "core/gd-ui/search/search";
import ErrorBoundary from "../../../../error-boundary";
import ExistingFields from "./existing-fields";
import AddCustomField from "./add-custom-field";

export default class AddExisting extends BaseComponent {

    static propTypes = {
        params: PropTypes.object.isRequired,

        onSubmit: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
        onClickNew: PropTypes.func.isRequired
    };

    state = {
        searchString: ''
    };

    onClickNew = () => {
        this.props.onClickNew();
    }

    onExistingFieldSelect = (customField) => {
        this.props.onSubmit({customFieldId: customField.id});
    }

    onSearchChange = (searchString) => {
        this.setState({
            'searchString': searchString
        });
    };

    render() {
        return (
            <div className="v4-container placement-middle add-existing" onClick={this.props.onClick}>
                <ErrorBoundary>
                    <ModalV4HeaderWhite height={60} title="Add Custom Field" />
                    <div className="main">
                        <VScroll>
                            {this.props.params.notification && <div className="desc">{this.props.params.notification}</div>}

                            <div className="search">
                                <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                            </div>

                            <ExistingFields project={this.props.params.project}
                                            taskType={this.props.params.taskType}
                                            scope={this.props.params.scope}
                                            searchString={this.state.searchString}
                                            onExistingFieldSelect={this.onExistingFieldSelect}/>

                            <AddCustomField project={this.props.params.project}
                                            // organizationId={this.props.params.organizationId}
                                            onClickNew={this.onClickNew}/>
                        </VScroll>

                    </div>
                </ErrorBoundary>
            </div>
        );
    }
}